export const onServiceWorkerUpdateReady = () => {
    const answer = window.confirm(
      `Aplikacja została zaktualizowana ` +
        `Czy chcesz pobrać najnowszą wersję?`
    )
  
    if (answer === true) {
      window.location.reload()
    }
  }